<template>
  <div class="qr-code">
    <canvas
      ref="qrcode"
      :class="innerClass"
    />
    <slot />
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrCode',
  props: {
    url: {
      type: String,
      default () {
        return ''
      }
    },
    innerClass: {
      type: String,
      default () {
        return ''
      }
    },
    width: {
      type: Number,
      default () {
        return 237
      }
    },
    colorDark: {
      type: String,
      default () {
        return '#000'
      }
    },
    colorLight: {
      type: String,
      default () {
        return '#fff'
      }
    }
  },

  watch: {
    url: {
      handler () {
        this.initQRCode()
      }
    }
  },

  mounted () {
    this.initQRCode()
  },

  methods: {
    initQRCode () {
      const options = {
        margin: 1,
        width: this.width,
        color: {
          dark: this.colorDark,
          light: this.colorLight
        }
      }
      QRCode.toCanvas(this.$refs.qrcode, this.url, options, function (error) {
        if (error) console.error(error)
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.qr-code {
  @extend .flex-center-column
  position: relative
  width: 237px
  height: 237px
  background-color: $white

  &.is-transparent {
    background-color: transparent
  }
}

.qr-code-inner {
  padding: 5px
  background-color: $white
}
</style>
